import {
  Button,
  Flex,
  Img,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import { ReactNode } from "react";

type ModalMeta = {
  title?: string;
  desc?: string;
  open: boolean;
  close: () => void;
  children: ReactNode;
  width?: string;
};

export function ModalDefault({ open, close, title, desc, children, width }: ModalMeta) {
  const IsWide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: true,
    lg: true,
    xl: true
  });

  return (
    <Modal isOpen={open} onClose={close} size="3xl" motionPreset="slideInBottom">
      <ModalOverlay />
      <ModalContent w={!IsWide ? "90%" : width ? width : "620px"}>
        <ModalHeader display="flex" justifyContent="space-between" alignItems="center">
          <Flex direction="column">
            <Text color={"ll-blue.main"} fontWeight={"500"} fontSize={"h2"}>
              {title}
            </Text>
            <Text fontSize="text1" textStyle="Regular">
              {desc}
            </Text>
            {title === "Avaliações de Clientes" && (
              <Text fontSize="16px" textStyle="Regular">
                Todas as avaliações são feitas após um ano de uso do produto
              </Text>
            )}
          </Flex>
          <Img
            cursor={"pointer"}
            onClick={close}
            src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/close.svg"}
          />
        </ModalHeader>

        <ModalBody position="relative" minH="500px" px={{ base: "12px", lg: "24px" }}>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
